import React from 'react'
import { useParams } from "react-router-dom";

export default function IndividualUser() {
  let params = useParams();
  return (
    <div>IndividualUser {params.username}</div>
  )
}
